import React, {useState, useEffect} from 'react';
import { MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../../../presenters/screens/followup-subproject.presenter";
import IndMasterDetail from '../../indicators-master-detail';
import TableErrors from '../../table-errors';
import { Enums } from "@utils";

export interface IActivities{
    id: number;
    status: any;
    index:number;
	dataColumns: any;
	activities: any;
	screen: string;
	currentYear: any;
	saveTable: any;
	tableAlerts?: string;
	initialValidate: boolean;
	initialValidateActPlan?: boolean;
	dimensionData?: any;
}

const Activities: React.FC<any> = ({id, tableAlerts, status, index, dataColumns, activities, screen, currentYear, saveTable, initialValidate, dimensionData, initialValidateActPlan}: IActivities) => {
	const [data, setData] = useState([]);
	const [columns, setColumns] = useState([]);
	const [title, setTitle] = useState('');
	const [auxData, setAuxData] = useState(null);
    const view: IFollowupSubproject = {
		state: {
			dataColumns,
			dimensionData
		},
  	};

	const presenter = new FollowupSubProjectPresenter(view);  

	const getActivities = (act: any) => { 
		act = act.find((x: any) => x.idParent === id)

		//let data = [...act.data].filter((item: any) => item.plannedGoal !== null)

		let data = act.data.map((item: any) => {
			return {...item, selected:false}
		})

		/* let groupedActivities = false 
		data.forEach((actData: any) => {
			if(!!actData.plannedGoal) groupedActivities = true
		}) */

		setTitle(act.name)

		//if(groupedActivities) setData(data.filter((actData : any) => actData.plannedGoal))
		setData(data)

	}

	const getColumns = (status: any) => {        
		const auxCol = presenter.getIndType2Columns(status, currentYear);
		setColumns(auxCol)
	}
    
	useEffect(() => {
		getActivities(activities);
	}, [status?.CodigoDimension]);

	useEffect(() => {
		if(dataColumns?._values?.length) getColumns(status);
	}, [dataColumns, status?.CodigoDimension, presenter.subProjectMonths, status?.EnEdicion]);

	useEffect(() => {
        if((tableAlerts === `${id}-${index}-er-activities` || !tableAlerts || tableAlerts === 'All') && data && columns) {
			let asd = getAuxData()
            setAuxData(asd)
        }
    }, [data, tableAlerts, columns, initialValidate]); 

    const getAuxData = () => {
		return (
            <>
                <TableErrors 
					initialValidate={initialValidate}
					initialValidateActPlan={initialValidateActPlan}
					initialValidateEmptyValues={false}
					checkEmptyValues={(item: any) => presenter.checkEmptyValuesActivities(item, status)}
					checkEmptyPlan={(item: any) => presenter.checkEmptyPlan(item)}
					msgInitialError={presenter.followupLabels.get("completeFrameworkInformation")}
					tableAlerts={tableAlerts}
					calculatedSumPl={(data: any) => presenter.checkAchievement(data, Number(currentYear))}
					gridId={`${id}-${index}-er-activities`}
					followupLabels={presenter.followupLabels}
				/>
				{/* {(initialValidate && !data?.length) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.followupLabels.get("alertMinOneIndicatorRequired")}</h6> // Change alerts 128
                    </div>
                } */}
				{(!data?.length) && 
                    <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>
                        {presenter.followupLabels.get("errorPOPInfo")}
                    </div>
                }
				<MasterDataGrid
					id={`${id}-${index}-er-activities`}
					dataSource={data}
					columns={columns}
					keyExpr={"id"}
					allowCode={screen}
					gridTitle={title}
					gridHelpId={`tooltip-${id}-${index}-er-activities`}
					gridHelpText={presenter.followupLabels.get("helpActivities")}
					gridProps={{
						editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
						rowAlternationEnabled:false,
						activeStateEnabled:true, 
						hoverStateEnabled:true,
						selection:{
							mode:"single"
						}
					}}
					saveTable={saveTable}
				/> 
				<IndMasterDetail 
					data={[]} 
					status={status} 
					schema={activities.schema} 
					id={`${id}-${index}-er-activities-detail`} 
					dataColumns={dataColumns}
					gridId={`${id}-${index}-er-activities`}   
					screen={screen} 
					currentYear={currentYear}          
				/>
            </>
        )
    }

	return (
		<>
		{(columns.length) ?
			<>
				{auxData && auxData}
			</>           
			:
			<></>
		}
	</>
	)
};

export default Activities;